import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import {
    FormFieldComponentProps,
    ErrorId,
    ExtendedFieldId,
    FieldContent,
    Validator,
    setCustomValidator,
} from '@sheerid/jslib';

import { OptInInputComponent } from '../OptInInputComponent/OptInInputComponent';

export const ConfirmDischargeDateComponent = ({
    isErrored,
    isRequired,
    onChange,
    value = true || false,
}: FormFieldComponentProps) => {
    const confirmDischargeFieldId: ExtendedFieldId = 'confirmDischargeDate';

    // eslint-disable-next-line no-shadow
    const getOptInValidationError: Validator = (value: FieldContent): ErrorId => {
        const invalidError: ErrorId = 'invalidOptIn';
        if (isRequired && !value) {
            return invalidError;
        }
        return null;
    };

    setCustomValidator('confirmDischargeDate', getOptInValidationError);


    return (
        <div className="sid-field sid-opt-in">
            <div className="sid-l-space-top-md" />
            <label htmlFor={confirmDischargeFieldId}>
                <div className="sid-l-position">
                    <div className="sid-checkbox-container">
                        <div className="sid-checkbox">
                            <OptInInputComponent
                                isErrored={isErrored}
                                onChange={onChange}
                                value={value}
                            />
                        </div>
                        <div className="sid-checkbox__label">
                            <FormattedHTMLMessage
                                id="confirmDischargeDate"
                                defaultMessage="I confirm that I have been honorably discharged within the past 12 months"
                            />
                        </div>
                        { isErrored
                            ? (
                                <div className="sid-field-error">
                                    <FormattedHTMLMessage
                                        id="errorId.invalidOptIn"
                                        defaultMessage="Must be selected to continue"
                                    />
                                </div>
                            )
                            : null}
                    </div>
                </div>
            </label>
        </div>
    );
};
